<template>
  <div com-channel-tag class="com-channel-tag-list">
    <template v-if="label && !list.length">
      <span class="no-topic">暂无相关频道</span>
    </template>
    <template v-else>
      <i class="iconfont">&#xe640;</i>
      <TopicTitle
        v-for="tag in list"
        class="topic-tag-title"
        :id="tag.alias || tag.id"
        :title="tag.name"
        :key="tag.id"
      />
    </template>
  </div>
</template>

<script>

import VueTypes from 'vue-types'
import TopicTitle from '../title/TopicTitle'
export default {
  name: 'com-channel-tag-list',
  components: {
    TopicTitle
  },
  /**
   * 传入数据
   * @property {String}         label       频道列表的前置文案
   * @property {String|Number}  left        频道介绍的宽度
   * @property {String|Number}  space       每项频道的间隔
   * @property {Array<Object>}  list        频道列表
   * @property {String}         list.alias  频道别名
   * @property {Number}         list.id     频道 ID
   * @property {String}         list.name   频道名称
   */
  props: {
    label: VueTypes.string.def(''),
    left: VueTypes.oneOfType([Number, String]).def(0),
    space: VueTypes.oneOfType([Number, String]).def(8),
    list: VueTypes.arrayOf(Object).def([])
  },
  data () {
    return {

    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
.com-channel-tag-list {
  position: relative;
  // height: 16px;
  line-height: 17px;
  @extend %row;
  color: $blue;

  & .iconfont {
    position: relative; top: 1px; left: 2px;
    margin-right: 4px;
    @include lineFont(16, 100);
  }

  & .topic-tag-title {
    position: relative;
    @include lineFont(13, 400);
    color: $blue;
    
    @extend %transition;

    &:hover,
    &:active {
      // color: #3574E7;
      color: #387bf4;
    }
    &:active {
      transition: none;
    }

    &:after {
      content: '·';
      display: inline-block;
      padding: 0 7px;
      font-size: 16px;
      font-weight: 500;
    }
  }

  & .topic-tag-title:last-child {
    &:after {
      display: none;
    }
  }
}

</style>